import React, {Component} from 'react';

const ClassItem = ({raceDescription, raceName, classNames}) => (
	<div className={classNames}>
		<div className="game-class-box-description">
			{raceDescription}
		</div>
		<div className="game-class-box-name">
			{raceName}
		</div>
	</div>
)

class Races extends Component{
	render(){
		const ClassList = this.props.RacesList;
		return (
			<section id="sgSectionClasses" className="gcAd-section game-classes" data-section="3">
				{ClassList.map(race =>
					<ClassItem
						key={Object.keys(ClassList)[ClassList.indexOf(race)]}
						classNames={"game-class-box is-" + String(race.shortName).toLowerCase()}
						raceDescription={race.smallDescription}
						raceName={race.Name}
					/>
				)}
			</section>
		)
	}
}

export default Races;


// WEBPACK FOOTER //
// ./src/Components/Advert-Races.js